/* unplugin-vue-components disabled */import { render } from "./uploadMusic.vue?vue&type=template&id=9622c816&scoped=true"
import script from "./uploadMusic.vue?vue&type=script&lang=js"
export * from "./uploadMusic.vue?vue&type=script&lang=js"

import "./uploadMusic.vue?vue&type=style&index=0&id=9622c816&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9622c816"]])

export default __exports__